import {useEffect} from "react";
import {UseGetRequest, useGetRequest, UseGetRequestParams} from "./useGetRequest";

export interface UseReactiveGetRequestParams extends UseGetRequestParams {
}

export interface UseReactiveGetRequest<T> extends UseGetRequest<T> {
}

const useReactiveGetRequest = <T>({ requestUrl, queryParams, shouldAbort = false }: UseReactiveGetRequestParams): UseReactiveGetRequest<T> => {
  const {
    data,
    setData,
    isLoading,
    setIsLoading,
    error,
    setError,
    meta,
    setMeta,
    doRequest,
  } = useGetRequest<T>({requestUrl, queryParams, shouldAbort});

  useEffect(() => {
    doRequest()
  }, [doRequest]);

  return {
    data,
    setData,
    isLoading,
    setIsLoading,
    error,
    setError,
    meta,
    setMeta,
    doRequest,
  }
}

export { useReactiveGetRequest };